module.exports = __webpack_public_path__ + "static/media/OpenSans-Semibold.33f225b8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/fonts/OpenSans-Semibold.ttf
// module id = 27
// module chunks = 0